import { ENUM__redux_action } from '@/state/_base/ENUM__redux_action';
import { PayloadAction } from '@reduxjs/toolkit';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { STATE__generation } from '../STATE__generation';

export const LOCAL__generation_set_field_image_to_edit = (payload: FIELD__image_asset): PayloadAction<FIELD__image_asset> => ({
  type: ENUM__redux_action.GENERATION_SET_FIELD_IMAGE_TO_EDIT,
  payload,
});

export function INIT_LOCAL__generation_set_field_image_to_edit(state: STATE__generation, action: PayloadAction<FIELD__image_asset>) {
  let field_new = action.payload;
  let field_old = state.field_image_to_edit;

  if (field_old.is_stub() && field_new.is_stub()) return; //nothing changed
  if (field_new.meta.field_id == field_old.meta.field_id && field_new.meta.graph_id == field_old.meta.graph_id) return; //nothing changed

  state.field_image_to_edit = field_new.clone();
}
